import { ReactNode } from "react";
import { DashboardWidgetLiveBar } from "./DashboardWidgetLiveBar";

interface DashboardLiveWidgetShellProps {
    live: boolean;
    lastUpdatedAt: string | null;
    onRefresh: () => void;
    isRefreshing: boolean;
    showManualRefresh?: boolean;
    refreshLabel?: string;
    /** Last re-fetch error, shown inline on the live bar while stale content is kept. */
    error?: string | null;
    children: ReactNode;
}

/** Layout wrapper for dashboard widgets that support live refresh. */
export const DashboardLiveWidgetShell = ({
    live,
    lastUpdatedAt,
    onRefresh,
    isRefreshing,
    showManualRefresh,
    refreshLabel,
    error,
    children,
}: DashboardLiveWidgetShellProps) => (
    <div className="DashboardLiveWidget">
        <div className="DashboardLiveWidget__content">{children}</div>
        <DashboardWidgetLiveBar
            live={live}
            lastUpdatedAt={lastUpdatedAt}
            onRefresh={onRefresh}
            isRefreshing={isRefreshing}
            showManualRefresh={showManualRefresh}
            refreshLabel={refreshLabel}
            error={error}
        />
    </div>
);
